module.exports = function () {
    $(document).ready(function (event) {

        var helper = require('../../helper');
        var AjaxController = require('../../services/AjaxController');

        $(document).on('click', 'input[id^="client_view-"]', function(e){

            var that = this;
            var ticketId = $(that).data('ticket-id');
            var url = '/api/tickets/change-field';

            if (that.checked) { var newState = 1; } else { var newState = 0; }
            var data = {
                field: 'client_view',
                ticketId: ticketId,
                value: newState
            };
            var success = function (response) {
            //    console.log('Success');
            }
            var error = function (response) {
            //    console.log('Error');
            }

            AjaxController.prototype.send(url, data, success, error);
        });

	    $(document).on('click', 'input[id^="guardian_view-"]', function(e){

		    var that = this;
		    var ticketId = $(that).data('ticket-id');
		    var url = '/api/tickets/change-field';

		    if (that.checked) { var newState = 1; } else { var newState = 0; }
		    var data = {
			    field: 'guardian_view',
			    ticketId: ticketId,
			    value: newState
		    };
		    var success = function (response) {
			    //    console.log('Success');
		    }
		    var error = function (response) {
			    //    console.log('Error');
		    }

		    AjaxController.prototype.send(url, data, success, error);
	    });

    });
}();
